import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { ElectricTable, ElectricSearchFilter } from "./component";
import { CreateElectricModal } from "../../Modal/Electric/CreateElectricityModal";
import { ElectricsProps } from "./types";
import {
  EditElectricPlan,
  ElectricPlan,
} from "../../../../features/auth/store/types/electric-types";
import { EditElectricModal } from "../../Modal/Electric/EditElectricityModal";
import { DeleteElectricityModal } from "../../Modal/Electric/DeleteElectricityModal";

const Electric: React.FC<ElectricsProps> = ({
  electricPlans,
  loading,
  statusFilter,
  setStatusFilter,
  onElectricPlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedElectricPlan, setSelectedElectricPlan] = useState<
    undefined | ElectricPlan
  >(undefined);
  const [electricPlanId, setElectricPlanId] = useState<number | null>(null);

  const onEditClick = (electricPlan: ElectricPlan) => {
    setSelectedElectricPlan(electricPlan);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setElectricPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Electric Plans">
          <div className="flex flex-col">
            <ElectricSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
            />
            <div className="border border-[#FFFFFF1A]">
              <ElectricTable
                electricPlans={electricPlans}
                statusFilter={statusFilter}
                onElectricPlanClick={onElectricPlanClick}
                onDeleteClick={onDeleteClick}
                onEditClick={onEditClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateElectricModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditElectricModal
          electricPlan={(selectedElectricPlan as EditElectricPlan) || undefined}
          isOpen={isEditModalOpen && selectedElectricPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedElectricPlan(undefined);
          }}
        />
        <DeleteElectricityModal
          id={electricPlanId}
          isOpen={isDeleteModalOpen && electricPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setElectricPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default Electric;
